module.exports = "data:application/x-tgif;base64,IyBCbGVuZGVyIHYyLjc5IChzdWIgMCkgT0JKIEZpbGU6ICdiYXJyZWxzLTEuYmxlbmQnCiMgd3d3LmJsZW5kZXIub3JnCnYgNi4wNTE3MDIgLTAuMDE4NzA2IC01LjI4NzU4MAp2IDYuMDUxNzAyIDYuMTM0NzM1IC01LjI4NzU4MAp2IDYuMDUxNzAzIC0wLjAxODcwNiA2LjQ5OTAyMQp2IDYuMDUxNzAzIDYuMTM0NzM1IDYuNDk5MDIxCnYgLTYuMDUxNzA0IC0wLjAxODcwNiAtNS4yODc1NzkKdiAtNi4wNTE3MDQgNi4xMzQ3MzUgLTUuMjg3NTc5CnYgLTYuMDUxNzAyIC0wLjAxODcwNiA2LjQ5OTAyMgp2IC02LjA1MTcwMiA2LjEzNDczNSA2LjQ5OTAyMgpsIDMgMQpsIDIgNApsIDQgMwpsIDcgMwpsIDQgOApsIDggNwpsIDUgNwpsIDggNgo="


//////////////////
// WEBPACK FOOTER
// ./src/components/app-experience/Experience/models/barrels-scene-room.obj
// module id = jV+K
// module chunks = 1